import React from 'react';
import MarkdownPageRenderer from '../../componentsV2/MarkdownPageRenderer/MarkdownPageRenderer';
import TermsMarkdown from './vamosTermsOfUseMarkdown.md';

const TermsPage = () => {
  return <MarkdownPageRenderer MarkdownContent={TermsMarkdown} />;
};

export default TermsPage;
